import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BlogModal from './BlogModal'; // Make sure this path is correct

const Blog = ({ filterData }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedBlogId, setSelectedBlogId] = useState(null);
    const [blogPosts, setBlogPosts] = useState([]);
    const [mobileView, setMobileView] = useState(false);

    const handleResize = () => {
        setMobileView(window.innerWidth <= 1008);
    };

    const fetchBlogPosts = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/blog`);
            setBlogPosts(res.data.reverse()); // Assuming you want the latest first
        } catch (err) {
            console.error('Error fetching blog posts:', err);
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        fetchBlogPosts(); // Initial fetch

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // If filterData (from a search/filter bar outside this component) is provided, use it
        if (filterData && filterData.length > 0) {
            setBlogPosts(filterData);
        } else if (filterData && filterData.length === 0) { // If filterData is empty, show no results
            setBlogPosts([]);
        } else {
             // If filterData is null/undefined or otherwise not actively filtering, re-fetch all to ensure fresh data
             fetchBlogPosts();
        }
    }, [filterData]);


    const openModal = (id) => {
        setSelectedBlogId(id);
        setModalOpen(true);
    };

    const onClose = () => {
        setModalOpen(false);
        setSelectedBlogId(null);
        fetchBlogPosts(); // Refresh blog posts after modal closes (e.g., after edit/add)
    };

    const deleteBlogPost = async (id) => {
        if (window.confirm("Are you sure you want to delete this blog post?")) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/blog/${id}`);
                fetchBlogPosts(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting blog post:', error);
            }
        }
    };

    return (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg *:font-sans">
        

            <table className="w-[83vw] text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ml-[8vw] md:ml-0">
                <thead className={`text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ${mobileView ? 'pl-[5vw] flex w-[80vw]' : ''}`}>
                    <tr>
                        <th scope="col" className="px-3 py-3">Title</th>
                        <th scope="col" className="px-3 py-3">Category</th>
                        <th scope="col" className="px-3 py-3">Description</th>
                        <th scope="col" className="px-3 py-3">Operations</th>
                    </tr>
                </thead>
                <tbody>
                    {blogPosts.length === 0 ? (
                        <tr>
                            <td colSpan="4" className="px-3 py-4 text-center text-gray-600">
                                No blog posts found.
                            </td>
                        </tr>
                    ) : (
                        blogPosts.map((post, index) => (
                            <tr
                                key={post.id}
                                className={`${index % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'} border-b dark:border-gray-700 ${mobileView ? 'ml-[5vw] flex flex-col' : ''}`}
                            >
                                <td className="px-3 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                    {post.title}
                                </td>
                                <td className="px-3 py-2">{post.category}</td>
                                <td className="px-3 py-2">
                                    {post.description
                                        ? (post.description.length > 50
                                            ? post.description.slice(0, 50) + '...'
                                            : post.description)
                                        : 'No description'}
                                </td>
                                <td className="px-3 py-2 flex flex-col md:flex-row gap-2">
                                    <button
                                        className="bg-gray-600 px-4 py-2 text-white rounded-xl duration-300 hover:bg-[#919191]"
                                        onClick={() => openModal(post.id)}
                                    >
                                        Edit/View
                                    </button>
                                    <button
                                        className="bg-red-500 px-4 py-2 text-white rounded-xl duration-300 hover:bg-red-400"
                                        onClick={() => deleteBlogPost(post.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                                {/* The BlogModal will be rendered based on modalOpen and selectedBlogId */}
                                <BlogModal isOpen={modalOpen && selectedBlogId === post.id} onClose={onClose} blogId={selectedBlogId} />
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Blog;